module.exports = __webpack_public_path__ + "odinstatic/media/placement.a1117be5.svg";